module.exports = __webpack_public_path__ + "img/snb_gsnd.2924fc71.svg";